import { TranslationKey } from './../../../../types/translation/TranslationKey';
import React, { useContext, useMemo, useState } from 'react';
import { t } from '../../../../types/translation/Translator';
import { BinContext } from '../../../../context/BinContext';
import { useNavigate } from 'react-router-dom';
import { Bin } from '../../../../types/bin/bin';
import { StockLocationContext } from '../../../../context/StockLocationContext';
import { BinStatusContext } from '../../../../context/BinStatusContext';
import BinStatusLabel from '../../Common/BinStatusLabel';
import Table from '../../../components/Table';
import { BinFilter } from '../../../../VentoryUI/components/filters/BinFilter';
import { TagRelationContext } from '../../../../context/TagRelationContext';
import { CustomFieldContext } from '../../../../context/CustomFieldContext';
import { Routing } from '../../../../util/routes.util';
import { SearchFilter } from '../../../components/Filter';
import { SettingsIconButton } from '../../../icons';
import { CompanyRoleAssignmentContext } from '../../../../context/CompanyRoleAssignmentContext';
import { CompanyContext } from '../../../../context/CompanyContext';

export default function BinOverviewPane() {
  const navigate = useNavigate();

  const { isAdmin } = useContext(CompanyRoleAssignmentContext);
  const { bins, binsLoading } = useContext(BinContext);
  const { stockLocations } = useContext(StockLocationContext);
  const { binStatuses } = useContext(BinStatusContext);
  const { tagRelations } = useContext(TagRelationContext);
  const { customFields } = useContext(CustomFieldContext);
  const { currentCompany, companies } = useContext(CompanyContext);

  const [items, setItems] = useState<Bin[]>([...bins.values()]);

  const isPartner = currentCompany.partner;

  const headers = [
    {
      key: 'company',
      name: t(TranslationKey.company).singular.label,
      text: (item: Bin) => companies.get(item.companyId)?.name || '',
    },
    {
      key: 'binName',
      name: t(TranslationKey.name).singular.label,
      text: (item: Bin) => bins.get(item.id)?.name || '',
    },
    {
      key: 'stockLocation',
      name: t(TranslationKey.stockLocation).singular.label,
      text: (item: Bin) => stockLocations.get(item.stockLocationId)?.name || '',
    },
    {
      key: 'status',
      name: t(TranslationKey.status).singular.label,
      text: (item: Bin) => <BinStatusLabel status={binStatuses.get(item.binStatusId)} />,
      sortValue: (item: Bin) => binStatuses.get(item.binStatusId),
    },
  ].filter(h => h.key !== 'company' || isPartner);

  const allItems = useMemo(() => {
    return [...bins.values()];
  }, [bins]);

  const filter = new BinFilter(binStatuses, tagRelations, customFields, bins, currentCompany, stockLocations);

  return (
    <div className='flex flex-grow flex-col gap-4'>
      <div className='flex justify-between gap-2'>
        <SearchFilter
          loading={binsLoading}
          items={allItems}
          setItems={setItems}
          placeholder={t(TranslationKey.filterBins).singular.label}
          filter={filter}
        />
        {isAdmin && <SettingsIconButton onClick={() => navigate(Routing.stock.bins.settings.binStatuses())} />}
      </div>

      <Table
        loading={binsLoading}
        items={items}
        totalItemCount={allItems.length}
        headers={headers}
        filter={filter}
        onClick={item => navigate(Routing.stock.bins.detail(item.id))}
      />
    </div>
  );
}
